module.exports = __webpack_public_path__ + "img/yxsjs.b470d15c.png";